/** @format */

import {Icon} from '@sttark/design-system';

export const QuoterValidation = ({icon, title, subTitle, steps = []}) => {
    return (
        <div className="quoter-validation-card">
            <div className="quoter-validation-card_header pt-1 pb-4 bg-structure-white d-flex align-items-center justify-content-center color-alert-negative ">
                <div className="me-3">
                    <Icon name={icon} color="#df3d33" />
                </div>

                {title ? (
                    <p className="font-body-md">{title}</p>
                ) : (
                    <p className="font-body-md">
                        Your order is <span className="font-body-bold-md">Incomplete</span>
                    </p>
                )}
            </div>
            <div className="quoter-validation-card_info-container p-4 bg-structure-lighter">
                <p className="font-body-bold-sm mb-1">{subTitle}</p>
                <ul className="info-container_list font-body-sm ps-2">
                    {steps.map((step, i) => (
                        <li key={i}>{step}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

QuoterValidation.displayName = 'QuoterValidation';

QuoterValidation.defaultProps = {
    icon: 'warning',
    subTitle: 'Items Incomplete',
    steps: [
        'Select Material & Laminate',
        'Select Shape & size',
        'Select Application',
        'Upload Artwork or Upload Later',
        'Provide Labels and Design Quantity'
    ]
};
